/* @flow */
import * as React from "react";
import styled from "styled-components";
import { Route } from "react-router-dom";
import Media from "react-media";
import { rgba } from "polished";
import { Link } from "../../common/Link";
import { InstrumentsIcon } from "../../Toolbar/Icons";
import Profit from "../Profit";

import ToggleSocial from "../../SocialTrading/ToggleSocial";

import type { TradeSettings } from "../../../redux/reducer/settings";
import { gaReducer } from "../../GA";
import ChartTypeTabs from "./ChartTypeTabs";

export const Bar = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0 15px;
`;

const ToggleSocialLink = styled(Link)`
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
  margin-left: 6px;
  margin-right: 6px;
  width: 26px;
  height: 26px;
  color: ${({ theme }) => rgba(theme.foreground, 0.7)};
  background-color: ${({ theme }) => rgba("#919191", 0.4)};
`;

const SettingsLink = styled(Link)`
  @media (max-width: 959px) {
    background-color: ${rgba("#919191", 0.4)};
    color: blueviolet;
    border-radius: 4px;
  }
`;

type Props = {
  settings: TradeSettings,
  activeStock: string
};

function ToolbarMobile(props: Props) {
  return (
    <React.Fragment>
      <Route
        path="/trade"
        render={() => (
          <Bar>
            <ToggleSocial
              as={ToggleSocialLink}
              replace
              to="/trade/social"
              onClick={() => {
                gaReducer("OPEN_SOCIAL_TRADING");
              }}
            />
            <ChartTypeTabs />
            <SettingsLink
              replace
              to="/trade/tools"
              onClick={() => {
                gaReducer("CLICKBTN_SHOW_TRADE_SETTINGS");
              }}
            >
              <Media query="(max-width: 479px)">
                {matches =>
                  matches ? (
                    <InstrumentsIcon width="18" />
                  ) : (
                    <InstrumentsIcon width="24" />
                  )
                }
              </Media>
            </SettingsLink>
          </Bar>
        )}
      />
      <Route
        path="/sightseeing"
        render={() => (
          <Bar>
            <ToggleSocial
              as={ToggleSocialLink}
              replace
              to="/trade/social"
              onClick={() => {
                gaReducer("OPEN_SOCIAL_TRADING");
              }}
            />
            <Profit percentage={90} />
            <Link
              replace
              to="/sightseeing/tools"
              onClick={() => {
                gaReducer("CLICKBTN_SHOW_TRADE_SETTINGS");
              }}
            >
              <InstrumentsIcon />
            </Link>
          </Bar>
        )}
      />
    </React.Fragment>
  );
}

export default ToolbarMobile;



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Toolbar/Toolbar.js